import React from 'react';
import {
  TemplateEight,
  TemplateSeven,
  TemplateSix,
  TemplateFive,
  TemplateFour,
  TemplateThree,
  TemplateTwo,
  TemplateOne,
} from '../components';
import { useHomePageQuery, useGetStarredSellerServices } from '../hooks';
import { Spinner } from '../components/atoms/spinner/spinner';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  templateStyle: {
    '--color-primary': theme.palette.primary.main,
    '--color-secondary': theme.palette.secondary.main,
    fontFamily: theme.typography.fontFamily,
  },
}));

const renderTemplate = (
  templateType,
  expertiseData,
  itemsTopSelling,
  preferredBrands,
  preferredProducts,
  brandsTopSelling,
  cardDetails,
  redirectToBuyerPortal,
  redirectToShopPortal,
  schedulerEnabled
) => {
  const templateProps = {
    preferredBrands: preferredBrands || [],
    brandsTopSelling: brandsTopSelling || [],
    expertiseData: expertiseData || [],
    itemsTopSelling: itemsTopSelling || [],
    preferredProducts: preferredProducts || [],
    cardDetails: cardDetails || {},
    redirectToBuyerPortal,
    redirectToShopPortal,
    schedulerEnabled,
  };

  switch (templateType) {
    case 'TemplateEight':
      return <TemplateEight {...templateProps} />;
    case 'TemplateSeven':
      return <TemplateSeven {...templateProps} />;
    case 'TemplateSix':
      return <TemplateSix {...templateProps} />;
    case 'TemplateFive':
      return <TemplateFive {...templateProps} />;
    case 'TemplateFour':
      return <TemplateFour {...templateProps} />;
    case 'TemplateThree':
      return <TemplateThree {...templateProps} />;
    case 'TemplateTwo':
      return <TemplateTwo {...templateProps} />;
    case 'TemplateOne':
      return <TemplateOne {...templateProps} />;
    default:
      return <TemplateOne {...templateProps} />;
  }
};

export const BusinessCard = ({
  cardDetails,
  cardLoading,
  schedulerEnabled,
}) => {
  const classes = useStyles();
  const { loading, data: serviceData } = useGetStarredSellerServices();

  const themeName = cardDetails?.current?.config?.seller?.profile?.themeName;

  const {
    preferredBrands,
    preferredProducts,
    brandsTopSelling,
    itemsTopSelling,
    isLoading,
  } = useHomePageQuery();

  const redirectToBuyerPortal = () => {
    const baseUrl = window.location.origin + window.location.pathname;
    const newUrl = baseUrl.replace('home', 'scheduler');
    window.location.href = newUrl;
  };

  const redirectToShopPortal = (shopUrl) => {
    window.location.href = shopUrl;
  };

  return (
    <>
      {loading || isLoading || cardLoading ? (
        <Spinner />
      ) : (
        <div className={`${classes.templateStyle}`}>
          {renderTemplate(
            themeName,
            serviceData?.starredSellerServices,
            itemsTopSelling,
            preferredBrands,
            preferredProducts,
            brandsTopSelling,
            cardDetails,
            redirectToBuyerPortal,
            redirectToShopPortal,
            schedulerEnabled
          )}
        </div>
      )}
    </>
  );
};
